import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { func, object, string } from "prop-types";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { hideModal } from "slices/app/actions/modals";
import { setHasUnsavedChanges } from "slices/app/appSlice";
import { removeBeforeUnload } from "slices/generativeAi/actions";

const HasUnsavedChangesModal = ({ onClick = () => {}, to, state }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickCancel = () => {
    dispatch(setHasUnsavedChanges(false));
    dispatch(removeBeforeUnload());

    dispatch(hideModal(modalTypes.HAS_UNSAVED_CHANGES));

    if (to) {
      const pathToSibling = pathname.split("/").slice(0, -1);
      const isRelative = !to.startsWith("/");
      const url = isRelative ? [...pathToSibling, to].join("/") : to;

      if (state) {
        navigate(url, { state });
      } else {
        navigate(url);
      }
    }

    onClick();
  };

  const onClickOK = () => {
    dispatch(removeBeforeUnload());
    dispatch(hideModal(modalTypes.HAS_UNSAVED_CHANGES));
  };

  return (
    <Modal
      data-testid="has-unsaved-changes-modal"
      onDismiss={onClickOK}
      className="fade-in"
      show
      centered
    >
      <Modal.Header>Unsaved Changes</Modal.Header>
      <Modal.Body>
        You have unsaved changes. Are you sure you want to leave this page?
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="cancelButton"
          variant={NewButtonVariant.l1}
          onClick={onClickCancel}
        >
          Leave without saving
        </NewButton>

        <NewButton
          data-test="okButton"
          variant={NewButtonVariant.l2}
          onClick={onClickOK}
        >
          Stay on Page
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

HasUnsavedChangesModal.propTypes = {
  onClick: func,
  to: string,
  state: object,
};

export default HasUnsavedChangesModal;
